/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsLogoList = {
    init: function ($section) {
      this.$section = $section
      Shopify.theme.jsLogoList = $.extend(this, Shopify.theme.getSectionData($section));

      this.logoPerRowLarge = this.logos_per_row

      this.$wrapper = this.$section.find('[data-slider]')
      this.$logos = this.$wrapper.find('.logo-list__item')
      this.logoSelector = `#${this.$section.attr('id')} .logo-list__item`

      this.initAnimation()
      this.handleEvents()
    },
    initAnimation: function () {

      if (this.timeline) {
        this.timeline.revert()
      }
      this.initSizes()
      this.initTimeline()
    },
    initSizes: function () {
      this.width = window.innerWidth
      if (isScreenSizeSmall()) {
        this.logos_per_row = 2
      } else if (isScreenSizeMedium()) {
        this.logos_per_row = 4
      } else {
        this.logos_per_row = this.logoPerRowLarge
      }
      this.logoWidth = (this.width * (100 / this.logos_per_row)) / 100
      this.totalWidth = this.logoWidth * this.total
      if (this.width > this.totalWidth || this.speed == 0 || this.$wrapper.length == 0) {
        console.log("removing class");
        this.$wrapper.removeClass('is-animating')
        return;
      }
      this.$wrapper.addClass('is-animating')
    },
    initTimeline() {
      let _self = this
      if (!this.$wrapper.hasClass('is-animating')) return;
      //Adjust Parent
      this.$wrapper.css('left', -this.logoWidth)
      this.$wrapper.css('width', (_self.width + _self.logoWidth))

      this.timeline = gsap.timeline({ paused: false });
      //Adjust Items
      this.timeline.set(this.logoSelector, {
        x: (i) => i * _self.logoWidth,
        width: this.logoWidth
      });
      //init timeline
      this.timeline.to(this.logoSelector, {
        duration: this.speed,
        ease: "none",
        x: `+=${(_self.totalWidth)}`,
        modifiers: {
          x: function (x) {
            x = parseFloat(x) % (_self.totalWidth);
            return x + "px";
          }
        },
        repeat: -1
      });
    },
    handleEvents: function () {
      $(window).on('resize', this.initAnimation.bind(this));
      this.$wrapper.hover(this.pauseTimeline.bind(this), this.resumeTimeline.bind(this));
    },
    pauseTimeline: function () {
      if (this.timeline)
        this.timeline.pause()
    },
    resumeTimeline: function () {
      if (this.timeline)
        this.timeline.play()
    },
    unload: function ($section) {

    }
  }

  /******/
})()
  ;